/*
 * @Author: JamesWong
 * @Description: 激活码模块中文包
 * @Date: 2018-11-29 19:12:37
 * @Last Modified by: JamesWong
 * @Last Modified time: 2019-01-02 11:36:13
 */
export default {
  activated: 'Activated',
  unactivated: 'Unactivated',
  order: 'Order',
  activeCode: 'Active Code',
  machineNumber: 'Machine Number',
  machineCode: 'Machine Code',
  activeTime: 'Active Time',
  operation: 'Operation',
  delete: 'Delete',
  dataNotAvailable: '暂无数据',
  cancelActived: 'Cancel Actived',
  cancel: 'Cancel',
  comfirm: 'Confirm',
  subactiveCodeCanceled: 'Sub-active Code Canceled！',
  subactiveCodeCanceledTips: 'Sure to cancel the active code for this device?',
  subactiveCodeDeleted: 'Sub-active Code Deleted！',
  subactiveCodeDeletedTips: 'Sure to cancel this active code？'
}


// WEBPACK FOOTER //
// ./src/i18n/en/activeCode.js